import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en/common.json';
import frTranslations from './locales/fr/common.json';
import ptTranslations from './locales/pt/common.json';
import ptBRTranslations from './locales/pt-BR/common.json';
import esTranslations from './locales/es/common.json';
import plTranslations from './locales/pl/common.json';
import deTranslations from './locales/de/common.json';
import trTranslations from './locales/tr/common.json';
import itTranslations from './locales/it/common.json';

const resources = {
  en: {
    common: enTranslations,
  },
  fr: {
    common: frTranslations,
  },
  pt: {
    common: ptTranslations,
  },
  'pt-BR': {
    common: ptBRTranslations,
  },
  es: {
    common: esTranslations,
  },
  pl: {
    common: plTranslations,
  },
  de: {
    common: deTranslations,
  },
  tr: {
    common: trTranslations,
  },
  it: {
    common: itTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    // Language mapping for regional variants
    load: 'languageOnly',
    
    // Language detection fallbacks
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
